import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "count"];
import { Fragment } from 'react';
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledNavItemLabel = styled.form.withConfig({
  displayName: "NavItemLabel__StyledNavItemLabel"
})(({
  $cssStyles
}) => {
  return Object.assign({
    display: 'flex',
    alignItems: 'center',
    flexGrow: '1',
    width: '100%'
  }, $cssStyles);
});
const Count = styled.span.withConfig({
  displayName: "NavItemLabel__Count"
})(({
  theme
}) => {
  return {
    marginLeft: 'auto',
    paddingLeft: theme.space['200']
  };
});
const isRenderable = children => children != null && children !== false;
export const NavItemLabel = _ref => {
  let {
      children,
      count
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsxs(StyledNavItemLabel, Object.assign({
    $cssStyles: cssStyles
  }, domProps, {
    children: [/*#__PURE__*/_jsx(Fragment, {
      children: children
    }), isRenderable(count) && /*#__PURE__*/_jsx(Count, {
      children: count
    })]
  }));
};
NavItemLabel.displayName = 'NavItemLabel';